// Cấu hình Cloudinary
// Thay thế các giá trị này bằng thông tin thực tế từ Cloudinary Dashboard

export const CLOUDINARY_CONFIG = {
  cloud_name: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'your_cloud_name',
  api_key: process.env.REACT_APP_CLOUDINARY_API_KEY || 'your_api_key',
  api_secret: process.env.REACT_APP_CLOUDINARY_API_SECRET || 'your_api_secret',
  upload_preset: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || 'your_upload_preset',
};

// Upload URL
export const CLOUDINARY_UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CONFIG.cloud_name}/upload`;

// Video Upload URL
export const CLOUDINARY_VIDEO_UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CONFIG.cloud_name}/video/upload`;
